// extracted by mini-css-extract-plugin
module.exports = {"documentsRelated":"styles_documentsRelated__3zt39","containerDocsRelated":"styles_containerDocsRelated__3JFeV"};